import React, { FC, Fragment } from 'react';
import InvoiceItem from 'components/manage-invoices/create-invoice-step-2/invoice-item/invoice-item.component';
import { CollectiveInvoiceSummary, InvoiceLineItem } from 'models/invoice';

type InvoiceSettingsProps = {
    invoices: CollectiveInvoiceSummary[];
    priceMap: { [key: string]: number };
    disabledInvoiceKeys: Set<string>;
    onPaymentTermChange: (paymentTerm: number, invoiceKey: string) => void;
    onInvoiceNumberChange: (invoiceNumber: string, invoiceKey: string) => void;
    onLineItemsChange: (invoiceKey: string, lineItem?: InvoiceLineItem, id?: number) => void;
    handleLineItemSelection: (invoiceKey: string, isChecked: boolean, orderId?: string, noteId?: string) => void;
    onInvoiceToggle: (invoiceKey: string, isEnabled: boolean) => void;
};
const InvoiceSettings: FC<InvoiceSettingsProps> = ({
    invoices,
    priceMap,
    disabledInvoiceKeys,
    onPaymentTermChange,
    onInvoiceNumberChange,
    onLineItemsChange,
    handleLineItemSelection,
    onInvoiceToggle,
}: InvoiceSettingsProps) => {
    return (
        <Fragment>
            {invoices.map((invoice, index) => (
                <InvoiceItem
                    handleLineItemSelection={handleLineItemSelection}
                    onPaymentTermChange={onPaymentTermChange}
                    onInvoiceNumberChange={onInvoiceNumberChange}
                    onLineItemsChange={onLineItemsChange}
                    onInvoiceToggle={onInvoiceToggle}
                    key={index}
                    currency={invoice.currency}
                    totalPrice={priceMap[invoice.key]}
                    invoice={invoice}
                    index={index}
                    isEnabled={!disabledInvoiceKeys.has(invoice.key)}
                />
            ))}
        </Fragment>
    );
};

export default InvoiceSettings;
